import { CarDefaultSplitAttribute } from './carDataAttributes';
import { ComicDefaultSplitAttribute } from './comicDataAttributes';
import { WatchDefaultSplitAttribute } from './watchDataAttributes';
import { OtherDefaultSplitAttribute } from './otherDataAttributes';
import { ArtDefaultSplitAttribute } from './artDataAttributes';
import { AntiqueDefaultSplitAttribute } from './antiqueDataAttributes';
import { BookDefaultSplitAttribute } from './bookDataAttributes';
import { CameraDefaultSplitAttribute } from './cameraDataAttributes';
import { FirearmDefaultSplitAttribute } from './firearmDataAttributes';
import { HandbagDefaultSplitAttribute } from './handbagDataAttributes';
import { JewelryDefaultSplitAttribute } from './jewelryDataAttributes';
import { ToyDefaultSplitAttribute } from './toyDataAttributes';
import { SportsCardDefaultSplitAttribute } from './sportsCardDataAttributes';
import { VinylRecordDefaultSplitAttribute } from './vinylRecordDataAttributes';
import { CoinDefaultSplitAttribute } from './coinDataAttributes';
import { StampDefaultSplitAttribute } from './stampDataAttributes';
import { HistoricalMemDefaultSplitAttribute } from './historicalMemorabiliaDataAttributes';
import { MovieMemDefaultSplitAttribute } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentDefaultSplitAttribute } from './musicalInstrumentDataAttributes';
import { MusicMemDefaultSplitAttribute } from './musicMemorabiliaDataAttributes';
import { SportsMemDefaultSplitAttribute } from './sportsMemorabiliaDataAttributes';
import { WineDefaultSplitAttribute } from './wineDataAttributes';

const splitAttrs = {
  ART: ArtDefaultSplitAttribute,
  ANTIQUE: AntiqueDefaultSplitAttribute,
  BOOK: BookDefaultSplitAttribute,
  CAMERA: CameraDefaultSplitAttribute,
  COMIC: ComicDefaultSplitAttribute,
  CAR: CarDefaultSplitAttribute,
  FIREARM: FirearmDefaultSplitAttribute,
  HANDBAG: HandbagDefaultSplitAttribute,
  JEWELRY: JewelryDefaultSplitAttribute,
  TOY: ToyDefaultSplitAttribute,
  SPORTS_CARD: SportsCardDefaultSplitAttribute,
  WATCH: WatchDefaultSplitAttribute,
  VINYL_RECORD: VinylRecordDefaultSplitAttribute,
  OTHER: OtherDefaultSplitAttribute,
  COIN: CoinDefaultSplitAttribute,
  STAMP: StampDefaultSplitAttribute,
  MUSICAL_MEM: MusicMemDefaultSplitAttribute,
  SPORTS_MEM: SportsMemDefaultSplitAttribute,
  HISTORIC_MEM: HistoricalMemDefaultSplitAttribute,
  MOVIE_MEM: MovieMemDefaultSplitAttribute,
  MUSICAL_INST: MusicalInstrumentDefaultSplitAttribute,
  WINE: WineDefaultSplitAttribute,
};

export default splitAttrs;



// WEBPACK FOOTER //
// ./src/config/defaultSplitAttributes.js